import FixedTextData from './FixedTextContent';

const customZPLhNode = {
    isError: true,
    fixedText: 'Preview not supported for custom ZPL',
    hNodeType: 'CustomZplContent'
};

export default function CustomZplContent(props) {
    return FixedTextData({ ...props, hNode: customZPLhNode });
}
